<template>
  <div>
    <div>
    </div>
    <b-container>
    <b-row v-if="$route.name == 'reports'" class="reportNameBlock">
      <b-col lg="6" sm="12">
        <h2 class="heading" >{{data.full_name}}</h2>
        <h2 class="courseHeading" >{{data.course_dates}}</h2>
      </b-col>
      <b-col lg="6" sm="12">
        <div :class="drop">
          <b-nav card-header pills>
            <b-dropdown
              v-if="Array.isArray(tm_params.reports.reports_entry)"
              :text="title"
              class="dropdownReports"
            >
              <b-dropdown-item
                v-on:click="changeReport"
                v-for="(reports, index) in filterExemptions"
                :key="'fourtydex' + index"
                :title="reports.report_url"
                :value="reports.report_title"
                >{{ reports.report_title }}</b-dropdown-item
              >
            </b-dropdown>
            <b-dropdown
              v-else
              text="Please Select a Report"
              class="dropdownReports"
            >
              <b-dropdown-item
                v-on:click="changeReport"
                v-for="(reports, index) in tm_params.reports"
                :key="'fourtyonedex' +index"
                :text="title"
                :value="reports.report_title"
                >{{ reports.report_title }}</b-dropdown-item
              >
            </b-dropdown>
            <!-- <b-button onclick="window.print()" class="print">Print</b-button> -->
          </b-nav>
        </div>        
      </b-col>
    </b-row>

      <b-row style="margin-left: 0">
        <b-col
          v-if="tm_params.multi_course === 'Y'"
          class="col-md-6 multi"
        >
          <span>Courses:</span>

          <span
            class="multiList"
            v-for="(multi, index) in tm_params.courses.courses_entry"
            :key="'fourtytwodex' +index"
          >
            <span :class="multi.course_X_colour">•</span
            ><span class="multiName">{{ multi.course_X_id }}</span>
          </span>
        </b-col>
      </b-row>
      <div class="reports">
        <div
          v-if="
            this.currentReport.indexOf('tmentry') !== -1 ||
              this.currentReport.indexOf('tmdraw') !== -1 ||
              this.currentReport.indexOf('tmresult') !== -1 ||
              this.currentReport.indexOf('tmoomt') !== -1
          "
        >
          <ReportTable
            :data="data"
            :previousData="previousData"
            :home="home"
            :title="title"
            :config="config"
            :team="teamEvent"
            :match="tm_params.match_play"
            :useName="tm_params.use_full_name"
            :showGender="showGender"
            :Stableford="Stableford"
            :represents_ind="represents_ind"
            :represents_heading="represents_heading"
            :represents_flag_type="represents_flag_type"
            :is_qualifier="is_qualifier"
            :show_info_web="show_info_web"
            :hide_score_card="hide_score_card"
            :id="id"
            :code="code"
            :season="id"
            :ReportcolourTour="ReportcolourTour"
            :tour="tournID"
            :cptTour="tournID"
          />
        </div>
        <div v-else-if="this.currentReport.indexOf('tmlsmon') !== -1 || this.currentReport.indexOf('tmscores') !== -1 || this.currentReport.indexOf('tmcrsts') !== -1">
          <b-tabs content-class="mt-3">
            <template v-if="data.hide_gross_sb == 'Y'">
              <b-tab title="Leaderboard" active>
                <template v-if="data.stableford == 'Y'">
                  <ScoreTeamSST
                    :data="data"
                    :previousData="previousData"
                    :home="home"
                    :title="title"
                    :config="config"
                    :team="team"
                    :match="match"
                    :updown="updown"
                    :showGender="showGender"
                    :represents_ind="represents_ind"
                    :represents_heading="represents_heading"
                    :represents_flag_type="represents_flag_type"
                    :is_qualifier="is_qualifier"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :id="id"
                    :code="code"
                    :season="id"
                  />
                </template>
                <template v-else>
                  <ReportTable
                    :data="data"
                    :previousData="previousData"
                    :home="home"
                    :title="title"
                    :config="config"
                    :team="teamEvent"
                    :match="tm_params.match_play"
                    :useName="tm_params.use_full_name"
                    :showGender="showGender"
                    :Stableford="Stableford"
                    :represents_ind="represents_ind"
                    :represents_heading="represents_heading"
                    :represents_flag_type="represents_flag_type"
                    :is_qualifier="is_qualifier"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :id="id"
                    :code="code"
                    :season="id"
                  />
                </template>
              </b-tab>
              <b-tab title="Hole by Hole" :title-item-class="'showDesk'">
                <HBH 
                  :tabs="tabs" 
                  :config="config" 
                  :title="title" 
                  :scores="data.team_scores.team_scores_entry"
                  :data="data"
                  :show_info_web="show_info_web"
                  :hide_score_card="hide_score_card"
                  :useName="tm_params.use_full_name"
                  :id="id"
                  :code="code"
                  :season="id"
                />
              </b-tab>
            </template>
            <template v-else>
              <!-- <template v-if="data.tt_code == '2B'">
                <b-tab title="Leaderboard" active>
                  <template v-if="data.stableford == 'Y'">
                    <ScoreTeamSST
                      :data="data"
                      :previousData="previousData"
                      :home="home"
                      :title="title"
                      :config="config"
                      team="Y"
                      :match="match"
                      :updown="updown"
                      :showGender="showGender"
                      :represents_ind="represents_ind"
                      :represents_heading="represents_heading"
                      :represents_flag_type="represents_flag_type"
                      :is_qualifier="is_qualifier"
                      :show_info_web="show_info_web"
                      :hide_score_card="hide_score_card"
                      :id="id"
                      :code="code"
                      :season="id"
                    />
                  </template>
                  <template v-else>
                    <ReportTable
                      :data="data"
                      :previousData="previousData"
                      :home="home"
                      :title="title"
                      :config="config"
                      :team="teamEvent"
                      :match="tm_params.match_play"
                      :useName="tm_params.use_full_name"
                      :showGender="showGender"
                      :Stableford="Stableford"
                      :represents_ind="represents_ind"
                      :represents_heading="represents_heading"
                      :represents_flag_type="represents_flag_type"
                      :is_qualifier="is_qualifier"
                      :show_info_web="show_info_web"
                      :hide_score_card="hide_score_card"
                      :id="id"
                      :code="code"
                      :season="id"
                    />
                  </template>
                </b-tab>
                <b-tab title="Hole by Hole" :title-item-class="'showDesk'">
                  <template v-if="data.stableford == 'Y'">
                    <HBH 
                      :tabs="tabs" 
                      :config="config" 
                      :title="title" 
                      :scores="data.team_scores.team_scores_entry"
                      :data="data"
                      :show_info_web="show_info_web"
                      :hide_score_card="hide_score_card"
                      :useName="tm_params.use_full_name"
                      :id="id"
                      :code="code"
                      :season="id"
                    />
                  </template>
                  <template v-else>
                    <HBH 
                      :tabs="tabs" 
                      :config="config" 
                      :title="title" 
                      :scores="data.scores.scores_entry"
                      :data="data"
                      :show_info_web="show_info_web"
                      :hide_score_card="hide_score_card"
                      :useName="tm_params.use_full_name"
                      :id="id"
                      :code="code"
                      :season="id"
                    />
                  </template>
                </b-tab>
              </template> -->
              <template v-if="data.match_play == 'N' && data.team_scoreboard_only == 'N'">
                <b-tab title="Leaderboard" active :title-item-class="{tabWidth: teamEvent == 'Y'}">
                  <ReportTable
                    :data="data"
                    :previousData="previousData"
                    :home="home"
                    :title="title"
                    :config="config"
                    team="N"
                    :match="tm_params.match_play"
                    :useName="tm_params.use_full_name"
                    :showGender="showGender"
                    :Stableford="Stableford"
                    :represents_ind="represents_ind"
                    :represents_heading="represents_heading"
                    :represents_flag_type="represents_flag_type"
                    :is_qualifier="is_qualifier"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :id="id"
                    :code="code"
                    :season="id"
                  />
                </b-tab>
                <b-tab title="Team" v-if="teamEvent === 'Y'" :title-item-class="{tabWidth: teamEvent == 'Y'}">
                  <ScoreTeamSST
                    :data="data"
                    :previousData="previousData"
                    :home="home"
                    :title="title"
                    :config="config"
                    :team="teamEvent"
                    :match="tm_params.match_play"
                    :useName="tm_params.use_full_name"
                    :showGender="showGender"
                    :Stableford="Stableford"
                    :represents_ind="represents_ind"
                    :represents_heading="represents_heading"
                    :represents_flag_type="represents_flag_type"
                    :is_qualifier="is_qualifier"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :id="id"
                    :code="code"
                    :season="id"
                  />
                </b-tab>
                <template v-if="data.tt_code != '2B'">
                  <b-tab title="Hole by Hole" :title-item-class="{tabWidth: teamEvent == 'Y'} || 'showDesk'" >
                    <HBH 
                      :tabs="tabs" 
                      :config="config" 
                      :title="title" 
                      :scores="data.scores.scores_entry"
                      :data="data"
                      :show_info_web="show_info_web"
                      :hide_score_card="hide_score_card"
                      :useName="tm_params.use_full_name"
                      :id="id"
                      :code="code"
                      :season="id"
                    />
                  </b-tab>
                </template>
              </template>
              <template v-else-if="data.match_play == 'N' && data.team_scoreboard_only == 'Y'">
                <b-tabs content-class="mt-3">
                  <b-tab
                    title="Leaderboard"
                    active
                    :title-item-class="bkColor"
                  >
                   <ScoreTeamSST
                        :data="data"
                        :previousData="previousData"
                        :home="home"
                        :title="title"
                        :config="config"
                        :team="teamEvent"
                        :match="tm_params.match_play"
                        :useName="tm_params.use_full_name"
                        :showGender="showGender"
                        :Stableford="Stableford"
                        :represents_ind="represents_ind"
                        :represents_heading="represents_heading"
                        :represents_flag_type="represents_flag_type"
                        :is_qualifier="is_qualifier"
                        :show_info_web="show_info_web"
                        :hide_score_card="hide_score_card"
                        :id="id"
                        :code="code"
                        :season="id"
                      />
                  </b-tab>
                  <template v-if="teamEvent === 'Y'">
                    <b-tab title="Hole-by-Hole" :title-item-class="'hideHBH' && bkColor" >
                      <HBH 
                        :tabs="tabs" 
                        :config="config" 
                        :title="title" 
                        :scores="data.team_scores.team_scores_entryscores_entry"
                        :data="data"
                        :show_info_web="show_info_web"
                        :hide_score_card="hide_score_card"
                        :useName="tm_params.use_full_name"
                        :id="id"
                        :code="code"
                        :season="id"
                      />
                    </b-tab>
                  </template>
                  <template v-else>
                    <template v-if="data.hole_by_hole != 'N'">
                      <b-tab title="Hole-by-Hole" :title-item-class="'hideHBH' && bkColor" >
                      <HBH 
                        :tabs="tabs" 
                        :config="config" 
                        :title="title" 
                        :scores="data.scores.scores_entry"
                        :data="data"
                        :show_info_web="show_info_web"
                        :hide_score_card="hide_score_card"
                        :useName="tm_params.use_full_name"
                        :id="id"
                        :code="code"
                        :season="id"
                      />
                      </b-tab>
                    </template>
                  </template>
                </b-tabs>
              </template>
              <template v-else>
                  <ReportTable
                    :data="data"
                    :previousData="previousData"
                    :home="home"
                    :title="title"
                    :config="config"
                    team="N"
                    :match="tm_params.match_play"
                    :useName="tm_params.use_full_name"
                    :showGender="showGender"
                    :Stableford="Stableford"
                    :represents_ind="represents_ind"
                    :represents_heading="represents_heading"
                    :represents_flag_type="represents_flag_type"
                    :is_qualifier="is_qualifier"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :id="id"
                    :code="code"
                    :season="id"
                  />
              </template>
            </template>
          </b-tabs>
        </div>
      </div>
    </b-container>
    <div
      v-show="livemessage == 'Y' || playSuspended == 'Y'"
      class="livemessage"
      :class="{ colorMess: playSuspended == 'Y' }"
    >
      <div>
        <h3 v-show="playSuspended == 'Y'" class="livemestext">
          Play Suspended
        </h3>
        <h3
          v-show="livemessage == 'Y' && livemessageText.length > 0"
          class="livemestext"
        >
          {{ livemessageText }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
// import Live from "@/views/live.vue";
import ReportTable from "@/components/reportTable.vue";
import apiCall from "@/services/api.js";
import { HBH, ScoreTeamSST } from "@ocs-software/vue-ocs";
export default {
  name: "Reports",
  components: {
    // Live,
    ReportTable,
    HBH,
    ScoreTeamSST
  },
  props: ["config"],
  data() {
    return {
      data: [],
      previousData: [],
      tm_params: [],
      drop: "drop",
      currentReport: this.$route.query.url,
      home: false,
      tabs: true,
      title: this.$route.query.title,
      id: this.$route.query.id,
      code: this.$route.query.code,
      tournID: this.$route.query.tour
    };
  },
  methods: {
    changeReport: function(event) {
      var report = event.target.getAttribute("title");
      var title = event.target.getAttribute("value");
      this.title = title;
      return (
        (this.currentReport = report),
        this.callOne()
      );
    },
    updateStuff: async function() {
      this.callOne();
      // try {
      //   console.log('in update')
      //   // First call, await for call to return
      //   let first_call = await apiCall.report(this.reportTitle);
      //   this.data = first_call.data;
      //   console.log("this.data -- update")
      //   console.log(this.data)
      //   // this.DEFIMAGESAMS3 = first_call.data.tm_params.DEFIMAGESAMS3;
      //   this.loading = false;
      //   // Second call, await for call to return
      //   let second_call = await apiCall.tmParams(this.id, this.code);
      //   // this.DEFIMAGESAMS3 = second_call.data.tm_params.DEFIMAGESAMS3;
      //   this.tm_params = second_call.data;
      //   console.log('this.tm_params -- update')
      //   console.log(this.tm_params)
      //   // this.callOne();
      //   this.loading = false;
      // } catch (error) {
      //   console.log("error in await calls");
      //   console.log(error);
      //   throw error;
      // }
    },
    callOne() {
      apiCall
        .report(this.reportTitle)
        .then(({ data }) => {
          this.data = data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },
  },
  computed: {
     filterExemptions: function() {
      return this.tm_params.reports.reports_entry.filter(
        reports_entry =>
          !reports_entry.report_title.indexOf("Tournament Entries") ||
          !reports_entry.report_title.indexOf("Draw") ||
          !reports_entry.report_title.indexOf("Round 1 Draw") ||
          !reports_entry.report_title.indexOf("Round 2 Draw") ||
          !reports_entry.report_title.indexOf("Round 3 Draw") ||
          !reports_entry.report_title.indexOf("Round 4 Draw") ||
          !reports_entry.report_title.indexOf("Round 5 Draw") ||
          !reports_entry.report_title.indexOf("Round 6 Draw") ||
          !reports_entry.report_title.indexOf("Round 1 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 2 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 3 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 4 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 5 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 6 Scores Only") ||
          !reports_entry.report_title.indexOf("Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 2 Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 3 Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 4 Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 5 Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 6 Scoreboard") ||
          !reports_entry.report_title.indexOf("Final Result")
        // !reports_entry.report_title.indexOf("Live Scoring Monitor")
      );
    },
    ReportcolourTour: function() {
      var backgroundColourTour = '';
      if (this.tournID == 'cpt') {
        backgroundColourTour = 'background-color: #bceff0; color:#081C3F'
      } else if (this.tournID== 'cp2') {
        backgroundColourTour = 'background-color: #bde9d8; color:#081C3F'
      } else if (this.tournID == 'cp3') {
        backgroundColourTour = 'background-color: #dfc3c2;color: #081C3F'
      } else if (this.tournID == 'pam') {
        backgroundColourTour = 'background-color: #081C3F; border: 0px solid #000; color: #fff'
      } else if (this.tournID == 'qsc') {
        backgroundColourTour = 'background-color: #ededc3'
      } else if (this.tournID == 'por') {
        backgroundColourTour = 'background-color: #c96b6b;color: #fff'
      }
      return backgroundColourTour
    },
    colourTour: function() {
      var backgroundColourTour = '';
      if (this.tournID == 'cpt') {
        backgroundColourTour = 'color: #bceff0; color:#bceff0'
      } else if (this.tournID== 'cp2') {
        backgroundColourTour = 'color:#bde9d8'
      } else if (this.tournID == 'cp3') {
        backgroundColourTour = 'color: #dfc3c2'
      } else if (this.tournID == 'pam') {
        backgroundColourTour = 'color: #081C3F'
      } else if (this.tournID == 'qsc') {
        backgroundColourTour = 'color: #ededc3'
      } else if (this.tournID == 'por') {
        backgroundColourTour = 'color: #c96b6b'
      }
      return backgroundColourTour
    },
    teamEvent: function(team) {
      var array = this.data;
      if (array["team_scores"] !== undefined) team = "Y";
      else team = "N";
      return team;
    },
    reportTitle: function(url) {
      if (this.currentReport.indexOf("tmentry") !== -1) {
        url =
          this.config.VUE_APP_API +
          this.config.VUE_APP_ID +
          "/cache/" +
          this.tournID +
          "/" +
          this.$route.query.id +
          "/" +
          this.$route.query.id +
          "-" +
          this.$route.query.code +
          "-entry-entries.json?randomadd=" +
          new Date().getTime();
      } else {
        if (this.currentReport.indexOf("tmscore") !== -1) {
          var subRep2 = this.currentReport.lastIndexOf("params=") + 7;
          var indNext2 = this.currentReport.indexOf("~", subRep2);
          var repParams = this.currentReport.substr(
            subRep2,
            indNext2 - subRep2
          );

          if (repParams && repParams.indexOf(".cgi") < 0) {
            url =
              this.config.VUE_APP_API +
              this.config.VUE_APP_ID +
              "/cache/" +
              this.tournID +
              "/" +
              this.$route.query.id +
              "/" +
              this.$route.query.id +
              "-" +
              this.$route.query.code +
              "-scores-" +
              repParams +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
          } else {
            url =
              this.config.VUE_APP_API +
              this.config.VUE_APP_ID +
              "/cache/" +
              this.tournID +
              "/" +
              this.$route.query.id +
              "/" +
              this.$route.query.id +
              "-" +
              this.$route.query.code +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
          }
        } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
          {
            url =
              this.config.VUE_APP_API +
              this.config.VUE_APP_ID +
              "/cache/" +
              this.tournID +
              "/" +
              this.$route.query.id +
              "/" +
              this.$route.query.id +
              "-" +
              this.$route.query.code +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
          }
        } else if (this.currentReport.indexOf("tmcrsts") !== -1) {
          {
            url =
              this.config.VUE_APP_API +
              this.config.VUE_APP_ID +
              "/cache/" +
              this.tournID +
              "/" +
              this.$route.query.id +
              "/" +
              this.$route.query.id +
              "-" +
              this.$route.query.code +
              "-scores-latest.json" +
              "?gt=y&randomaddMATT=" +
              new Date().getTime();
          }
        } else if (this.currentReport.indexOf("tmdraw") !== -1) {
          var subRep = this.currentReport.lastIndexOf("round=") + 6;
          var indNext = this.currentReport.indexOf("~", subRep);
          var drawRnd = this.currentReport.substr(subRep, indNext - subRep);
          url =
            this.config.VUE_APP_API +
            this.config.VUE_APP_ID +
            "/cache/" +
            this.tournID +
            "/" +
            this.$route.query.id +
            "/" +
            this.$route.query.id +
            "-" +
            this.$route.query.code +
            "-draw-R" +
            drawRnd +
            "-draw.json" +
            "?randomadd=" +
            new Date().getTime();
        } else if (this.currentReport.indexOf("tmresult") !== -1) {
          var subRep1 = this.currentReport.lastIndexOf("result=") + 7;
          var indNext1 = this.currentReport.indexOf("~", subRep1);
          var resNum1 = this.currentReport.substr(subRep1, indNext1 - subRep1);
          console.log("resNum === ");
          console.log(resNum1);
          url =
            this.config.VUE_APP_API +
            this.config.VUE_APP_ID +
            "/cache/" +
            this.tournID +
            "/" +
            this.$route.query.id +
            "/" +
            this.$route.query.id +
            "-" +
            this.$route.query.code +
            "-result-result-" +
            resNum1 +
            ".json" +
            "?randomadd=" +
            new Date().getTime();
        } else {
          url =
            this.config.VUE_APP_API +
            this.config.VUE_APP_ID +
            "/cache/" +
            this.tournID +
            "/" +
            this.$route.query.id +
            "/" +
            this.$route.query.id +
            "-" +
            this.$route.query.code +
            "-result-result-PF.json" +
            "?randomadd=" +
            new Date().getTime();
        }
      }
      return url;
    },
  },
  created() {
    setInterval(this.updateStuff, 30000);
  },
    async mounted() {
    try {
      // First call, await for call to return
      let first_call = await apiCall.report(this.reportTitle);
      this.data = first_call.data;
      this.loading = false;
      // Second call, await for call to return
      let second_call = await apiCall.tmParams(this.id, this.code, this.tournID);
      this.tm_params = second_call.data;
      this.DEFIMAGESAMS3 = second_call.data.tm_params.DEFIMAGESAMS3;
      this.showGender = second_call.data.show_gender;
      this.Stableford = second_call.data.stableford;
      this.show_info_web = second_call.data.tm_params.show_info_web;
      this.hide_score_card = second_call.data.hide_score_card;
      this.is_qualifier = second_call.data.is_qualifier;
      this.livemessage = second_call.data.live_message;
      this.livemessageText = second_call.data.live_scoring_mess;
      this.playSuspended = second_call.data.play_suspended;
      console.log("this.DEFIMAGESAMS3")
      console.log(this.DEFIMAGESAMS3)
      console.log("this.tm_params")
      console.log(this.tm_params)
      // this.DEFIMAGESAMS3 = second_call.data.tm_params.DEFIMAGESAMS3;
      this.loading = false;
    } catch (error) {
      console.log("error in await calls");
      console.log(error);
      throw error;
    }
  }
};
</script>

<style scoped>
.colorMess {
  background: red !important;
  color: white;
  font-weight: 500;
  text-align: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
}
.livemessage {
  background: #133f7b;
  color: white;
  font-weight: 500;
  text-align: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
}
.reportNameBlock {
  margin-top: 30px;
}
h2.heading {
  font-weight: 600;
  font-size: 36px;
  color: #081C3F;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
h2.courseHeading {
  /* font-weight: 600; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  font-size: 25px;
  color: #081C3F
}
::v-deep tr {
  border-bottom: 0px solid #E8E8E8;
}
::v-deep .nav-tabs {
  border-bottom: 0px solid #dee2e6;
}
span.multiName {
  padding-left: 5px;
  padding-right: 5px;
}
.B {
  color: #333333;
  font-size: 40px !important;
  line-height: 50px !important;
  vertical-align: middle;
  position: relative;
  top: -3px;
}
.Y {
  color: #d8db22;
  font-size: 40px !important;
  line-height: 50px !important;
  vertical-align: middle;
  position: relative;
  top: -3px;
}
.C {
  color: #1e90ff;
  font-size: 40px !important;
  line-height: 50px !important;
  vertical-align: middle;
  position: relative;
  top: -3px;
}
.R {
  color: #bb0000;
  font-size: 40px !important;
  line-height: 50px !important;
  vertical-align: middle;
  position: relative;
  top: -3px;
}
.G {
  color: #3c9933;
  font-size: 40px !important;
  line-height: 50px !important;
  vertical-align: middle;
  position: relative;
  top: -3px;
}
.O {
  color: #e07020;
  font-size: 40px !important;
  line-height: 50px !important;
  vertical-align: middle;
  position: relative;
  top: -3px;
}
.dropdownReports > button:hover {
  background-color: pink !important;
}

.drop {
  padding-left: 10px;
  padding-bottom: 50px;
  padding-top: 50px;
  float: right;
}
.sponsor {
  margin-top: -8em !important;
  margin-left: 10% !important;
  max-width: 136px;
  vertical-align: middle;
  margin-right: auto;
  margin-top: 20px;
  margin-bottom: 10px;
}
::v-deep button {
  font-size: 15px;
  padding-top: 6px;
  padding-bottom: 6px;
  background-color: #081C3F;
  color: #ffffff;
  border-radius: 0px;
  border: 0px;
  height: 30px;
  width: 100%;
  text-align: left;
  float: right;
  width: 244px;
  height: 50px;
  background: transparent;
  color: #8b8a8a;
  font-weight: 500;
  border: 1px solid #E8E8E8;
}
::v-deep button.btn.dropdown-toggle.btn-secondary {
  width: 100%;
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
  width: 424px;
  height: 52px;
  font-size: 18px;
  font-weight: 700;
  border-radius: 26px;
}
::v-deep button::after {
  float: right;
  margin-top: 10px;
}
::v-deep .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 18px;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  width: 97%;
}
.dropdown {
  padding-right: 15px;
}
.print {
  display: inline-block;
  margin-bottom: 0;
  font-size: 15px;
  font-weight: 400;
  line-height: 0.428571;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 0px;
  color: #fff;
  background-color: #081C3F;
  border-color: #081C3F;
  width: 120px;
}
::v-deep button:hover {
  color: #fff;
  background-color: #081C3F;
}
::v-deep .nav-link.active {
  color: white !important;
  background-color: #081C3F !important;
  width: 100%;
  border-color: #081C3F !important;
  height: 100%;
}

::v-deep .nav-link {
  color: black !important;
  width: 100%;
  font-size: 18pt;
}
::v-deep li.nav-item.tabWidth {
   width: 33.333%!important;
}
::v-deep li.nav-item {
  width: 50%;
  text-align: center;
}
::v-deep .mt-3 {
  margin-top: 0 !important;
}
@media only screen and (max-width: 990px) {
  ::v-deep li.nav-item.showDesk {
    display: none!important;
  }
  .dropdown {
    width: 100%;
  }
  ::v-deep .nav-link {
    color: black !important;
    width: 100%;
    font-size: 13px;
  }
}
@media only screen and (max-width: 980px) {
  .mobHide {
    display: none;
  }
  .drop {
    padding-left: 10px;
    padding-bottom: 50px;
    padding-top: 50px;
    float: left!important;
    width: 100%;
  }
}

@media only screen and (max-width: 480px) {
  .sponsor {
    margin-top: 2%;
    width: 35%;
    padding-left: 4%;
  }
}
</style>
